/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createFormQualityEntry } from '../fn/form-quality-entry/create-form-quality-entry';
import { CreateFormQualityEntry$Params } from '../fn/form-quality-entry/create-form-quality-entry';
import { deleteFormQualityEntry } from '../fn/form-quality-entry/delete-form-quality-entry';
import { DeleteFormQualityEntry$Params } from '../fn/form-quality-entry/delete-form-quality-entry';
import { FormQualityEntry } from '../models/form-quality-entry';
import { updateFormQualityEntries } from '../fn/form-quality-entry/update-form-quality-entries';
import { UpdateFormQualityEntries$Params } from '../fn/form-quality-entry/update-form-quality-entries';

@Injectable({ providedIn: 'root' })
export class FormQualityEntryService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `formQualityEntryControllerUpdateFormQualityEntries()` */
  static readonly FormQualityEntryControllerUpdateFormQualityEntriesPath = '/forms/{formId}/quality-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormQualityEntries()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormQualityEntries$Response(
    params: UpdateFormQualityEntries$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<FormQualityEntry>>> {
    return updateFormQualityEntries(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateFormQualityEntries$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormQualityEntries(
    params: UpdateFormQualityEntries$Params,
    context?: HttpContext
  ): Observable<Array<FormQualityEntry>> {
    return this.updateFormQualityEntries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FormQualityEntry>>): Array<FormQualityEntry> => r.body)
    );
  }

  /** Path part for operation `formQualityEntryControllerCreateFormQualityEntry()` */
  static readonly FormQualityEntryControllerCreateFormQualityEntryPath = '/forms/{formId}/quality-entry';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFormQualityEntry()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFormQualityEntry$Response(
    params: CreateFormQualityEntry$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<FormQualityEntry>> {
    return createFormQualityEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createFormQualityEntry$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFormQualityEntry(params: CreateFormQualityEntry$Params, context?: HttpContext): Observable<FormQualityEntry> {
    return this.createFormQualityEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<FormQualityEntry>): FormQualityEntry => r.body)
    );
  }

  /** Path part for operation `formQualityEntryControllerDeleteFormQualityEntry()` */
  static readonly FormQualityEntryControllerDeleteFormQualityEntryPath =
    '/forms/{formId}/quality-entry/{formQualityEntryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFormQualityEntry()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFormQualityEntry$Response(
    params: DeleteFormQualityEntry$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    return deleteFormQualityEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteFormQualityEntry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFormQualityEntry(params: DeleteFormQualityEntry$Params, context?: HttpContext): Observable<void> {
    return this.deleteFormQualityEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }
}
